import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ConnectorFormComponent} from "./connector-form.component";
import {NbInputModule, NbSelectModule} from "@nebular/theme";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";



@NgModule({
  declarations: [ConnectorFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NbInputModule,
    NbSelectModule
  ]
})
export class ConnectorFormModule { }
